

module.exports = __webpack_require__.stylable.create(
    "Manu4234380990",
    {"classes":{"root":"Manu4234380990__root","Divider":"Manu4234380990__Divider","ManuControllers":"Manu4234380990__ManuControllers","Close":"Manu4234380990__Close"},"vars":{},"stVars":{"ManuBackground":"\"fallback(color(--calendarBackgroundColorWithoutOpacity), color(color-1))\"","TextColor":"\"fallback(color(--eventTitleColor), fallback(color(--runningTextColor), color(color-5)))\"","DefaultFont":"\"{theme: 'Body-M', size: '16px', lineHeight: '16px'}\"","TextFont":"\"fallback(font({theme: 'Body-M', size: '16px', lineHeight: '16px'}))\""},"keyframes":{}},
    "",
    18,
    "Manu4234380990",
    null
);
